import { getKSTTodayStr } from '../../utils/dateUtils';
import { WALK_STORAGE_EVENT } from './constants';

const dailyKey = (uid) => `walk_daily_${uid}`;
const weekKey = (uid) => `walk_week_${uid}`;

const emptyDaily = () => ({
  date: getKSTTodayStr(),
  distanceM: 0,
  activeSec: 0,
  boxes: 0
});

const readJson = (key, fallback) => {
  try {
    return JSON.parse(localStorage.getItem(key)) || fallback;
  } catch (_) {
    return fallback;
  }
};

export function readWalkData(uid) {
  if (!uid) return { daily: emptyDaily(), days: [] };
  const today = getKSTTodayStr();
  let daily = readJson(dailyKey(uid), emptyDaily());
  let week = readJson(weekKey(uid), { days: [] });

  if (daily.date !== today) {
    const previous = {
      date: daily.date,
      distanceM: Number(daily.distanceM) || 0,
      activeSec: Number(daily.activeSec) || 0
    };
    const days = Array.isArray(week.days) ? week.days : [];
    week = {
      days: [...days.filter((day) => day.date !== previous.date), previous]
        .sort((a, b) => a.date.localeCompare(b.date))
        .slice(-7)
    };
    daily = emptyDaily();
    localStorage.setItem(weekKey(uid), JSON.stringify(week));
    localStorage.setItem(dailyKey(uid), JSON.stringify(daily));
  }

  return { daily, days: Array.isArray(week.days) ? week.days : [] };
}

export function addWalkSegment(uid, distanceM, activeSec) {
  if (!uid) return null;
  const { daily } = readWalkData(uid);
  const next = {
    ...daily,
    distanceM: Math.max(0, (Number(daily.distanceM) || 0) + distanceM),
    activeSec: Math.max(0, (Number(daily.activeSec) || 0) + activeSec)
  };
  localStorage.setItem(dailyKey(uid), JSON.stringify(next));
  window.dispatchEvent(new CustomEvent(WALK_STORAGE_EVENT, { detail: next }));
  return next;
}

export function getSevenDayWalkData(uid) {
  const { daily, days } = readWalkData(uid);
  const byDate = new Map(days.map((day) => [day.date, day]));
  byDate.set(daily.date, daily);

  const result = [];
  const todayUtc = new Date(`${getKSTTodayStr()}T00:00:00+09:00`);
  for (let offset = 6; offset >= 0; offset -= 1) {
    const date = new Date(todayUtc.getTime() - offset * 86400000);
    const dateStr = new Date(date.getTime() + 9 * 3600000).toISOString().slice(0, 10);
    result.push(byDate.get(dateStr) || { date: dateStr, distanceM: 0, activeSec: 0 });
  }
  return result;
}
